<template>
  <v-card class="upload-signature"
    flat>
    <v-layout
      column
      justify-center
      align-center>

      <p>Para assinar documentos, cadastre aqui</p>

      <v-btn
        color="accent"
        @click="toggleModalSignature(true)"
        flat
        small
      >
        <v-icon left>mdi-transcribe</v-icon>
        Enviar assinatura
      </v-btn>
    </v-layout>
  </v-card>
</template>

<script>
export default {
  name: 'UploadSignature',
  methods: {
    toggleModalSignature(value) {
      this.$store.dispatch('toggleModalSignature', value);
    },
  },
};
</script>

<style scoped lang="scss">
.upload-signature {
  padding: 2rem;
  border: 1px dashed rgba(#308afb, .25);
}
</style>



// WEBPACK FOOTER //
// src/components/account/signature/UploadSignature.vue